import type { ItemTypeV2, ObjectOrganization, ObjectOwner, ProfileIdentity } from '@/domain';
import type { HostBadgesData } from '@/hooks/useHostBadges';
import { ProfileCompany } from '../profileCompany/ProfileCompany';
import { ProfilePublic } from '../profilePublic/ProfilePublic';

export type ProfileProps = {
    hostBadges: HostBadgesData;
    itemType: ItemTypeV2;
    organisation?: ObjectOrganization;
    owner: ObjectOwner;
    profileIdentity?: ProfileIdentity;
};

export const Profile = ({ hostBadges, itemType, organisation, owner, profileIdentity }: ProfileProps) => {
    if (!owner) {
        return null;
    }

    if (itemType === 'import' && !owner.mobile && !owner.phone && !organisation) {
        return null;
    }

    return (
        <div className="p-16 border rounded-8" data-testid="objectPage-profile">
            <div data-testid="adProfile" className="text-center">
                {itemType === 'import' && <ProfileCompany organisation={organisation} />}

                {(itemType === 'tjvr' || itemType === 'classified') && <ProfilePublic identity={profileIdentity} badges={hostBadges} />}
            </div>
        </div>
    );
};
